import React from 'react';
import { Link } from 'react-router-dom';
import servicesData from '../../../data/services-data';
import ctaImage from '../../../assets/img/page/cta-1.jpg';
import image1 from '../../../assets/img/portfolio/portfolio-11.jpg';
import image2 from '../../../assets/img/portfolio/portfolio-12.jpg';
// import image2 from '../../../assets/img/portfolio/portfolio-8.jpg';

const ServicesEngineering = () => {
    return (
        <>
            <div className="services__details section-padding">
                <div className="container">
                    <div className="row">
                        {/* <div className="col-lg-4 columns_sticky">
                            <div className="all__sidebar">                        
                                <div className="all__sidebar-item">
                                    <h4>Our Solutions</h4>
                                    <div className="all__sidebar-item-category">
                                        <ul>
                                            {servicesData.slice(0, 5).map((data, id) => (
                                                <li key={id}><Link to={`/services/${data.id}`}>{data.title}<i className="flaticon-right-up"></i></Link></li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                                <div className="all__sidebar-item-help mb-25" style={{backgroundImage: `url(${ctaImage})`}}>
                                    <h3>Ready for Your Next Construction?</h3>
                                    <Link className="build_button mt-20" to="/contact-us">Get an Advice<i className="flaticon-right-up"></i></Link>
                                </div>
                                <div className="all__sidebar-item">
                                    <h4>Download</h4>
                                    <div className="all__sidebar-item-download">
                                        <ul>
                                            <li><Link to="#">Company Details<span className="fal fa-arrow-to-bottom"></span></Link></li>
                                            <li><Link to="#">Our Brochures<span className="fal fa-arrow-to-bottom"></span></Link></li>
                                        </ul>                            
                                    </div>
                                </div>
                            </div>  
                        </div> */}
                        <div className="col-lg-12">
                            <div className="services__details-area">
                                {/* <img src={singleData.image} alt="image" /> */}
                                {/* <h3 className="mt-25 mb-20">{servicesData.title}</h3> */}
                                
                                <h2 className="mb-20">Best-in-class Engineering Consulting Services for Iconic Building Design in Bangladesh</h2>

                                <h3 className="mb-20">Engineering Consultancy: Building the Future Together</h3>
                                <p className="mb-20">
                                    Welcome to the Engineering Consultancy section of Profile Ltd. Here, creativity and engineering genius combine to create structures that are a tribute to human ingenuity. Our journey together is about more than math and drawings; it’s about using engineering talent to turn aspirations into reality. Most of our engineers keep a deep eye on western engineering updates and as a result provide any kind of industry standard support.
                                </p>

                                <h3 className="mb-20">Structural Engineering: Crafting Foundations of Strength</h3>
                                <p className="mb-20">
                                    In the field of structural engineering, we develop lifelines that stand the test of time in addition to designing any building design in Bangladesh or abroad. Our engineers of strength design buildings that integrate form and function. Every support structure—beams, columns, and foundation stones—is set with care to sustain not just loads but also dreams. We include safety, aesthetics, and sustainability into the very foundation of your concept, whether it be for majestic skyscrapers or modest residential havens.
                                </p>
                                <div className="row mt-40 mb-40">
                                    <div className="col-sm-6 sm-mb-25">
                                        <img className="img_full" src={image1} alt="image" />
                                    </div>
                                    <div className="col-sm-6">
                                        <img className="img_full" src={image2} alt="image" />
                                    </div>
                                </div>

                                <h4 className="mb-20">Our Method:</h4>
                                <p className="mb-20">
                                    Our method is sound, much like the foundation of a sturdy building. We are your traveling partners, not just engineers. We pay attention, imagine, and then use our technical prowess. We make sure that the structural structure isn’t simply a backdrop but a crucial component of the narrative by working with architects, designers, and you.
                                </p>

                                <h3 className="mb-20">MEP Engineering: Giving Spaces Life</h3>
                                <p className="mb-20">
                                    The veins and nerves of every contemporary structure are the mechanical, electrical, and plumbing (MEP) systems. Our MEP engineers breathe life into places, ensuring that they are practical, eco-friendly, and cozy. More than simply pipes and wires are involved; instead, an atmosphere that supports possibilities and life must be created.
                                </p>

                                <h4 className="mb-20">Our Methodology:</h4>
                                <p className="mb-20">
                                    Our methodology is integrated, much like MEP systems are. We are aware of western engineering updates and the dance between efficiency and effectiveness, mechanics and beauty. We create systems that function effectively in the actual world as well as on paper. We choreograph components that augment living experiences, from heating systems that love winters to lighting solutions that dance with ambience.
                                </p>

                                <h3 className="mb-20">The Heart of It All: Partnership</h3>
                                <p className="mb-20">
                                    Engineering is a symphony of ideas and knowledge; it is not a single endeavor. At Profile Ltd, we like working together. We pay attention to your concept, discuss it with architects, and work out the kinks with contractors. Our success is based on our ability to combine many threads into a tapestry that is both useful and beautiful.
                                </p>

                                <h3 className="mb-20">Beyond Engineering: Crafting Relationships</h3>
                                <p className="mb-20">
                                    Every project is an adventure for us, and every client is an associate. Our dedication extends beyond the structures we build and includes the connections we make. We pledge to be transparent with you, offer creative ideas, and work together to realize your aspirations.
                                </p>

                                <h3 className="mb-20">Let’s Start the Journey Now</h3>
                                <p className="mb-20">
                                    Beginning here is the journey from blueprint to skyline, from dream to reality. It begins with a discussion in which dreams and goals are shared. To create one of the best building designs in Bangladesh or anywhere, just tap and start a journey that offers more than simply engineering consulting—get in touch with Profile Ltd. We’ll work with you to create the future.
                                </p>


                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>          
        </>
    );
};

export default ServicesEngineering;